import { getApp, getApps, initializeApp } from 'firebase/app';
import { GoogleAuthProvider, getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyD2d_lEWF6Tm4xoU9khAIJIUcPwfxhdH0w',
  authDomain: 'brassfl.firebaseapp.com',
  projectId: 'brassfl',
  storageBucket: 'brassfl.firebasestorage.app',
  messagingSenderId: '546336272396',
  appId: '1:546336272396:web:3d8fa1e1642deb5b637e29',
  measurementId: 'G-MET2ST4XMR',
};

const firestoreApp = initializeApp(firebaseConfig);

const googleAuthProvider = new GoogleAuthProvider();
const auth = getAuth(firestoreApp);

export { auth, googleAuthProvider };

// Not found in imran's github repo
export const db = getFirestore(firestoreApp);
export const googleProvider = new GoogleAuthProvider();
